import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export interface UserPaymentLinkItem {
    id: string;
    amount: number;
    currency: string;
    description?: string;
    status: string;
    createdAt: string;
    paidAt?: string;
    checkoutUrl?: string;
    expiresAt?: string;
}

export const GET_PAYMENT_LINKS_QUERY_KEY = (userId: string) => ['payments', 'admin', 'users', userId, 'payment-links'];

export function useGetPaymentLinks(userId: string) {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_PAYMENT_LINKS_QUERY_KEY(userId),
        queryFn: () =>
            client.fetchApi<UserPaymentLinkItem[], {}>({
                endpoint: `payments/admin/users/${userId}/payment-links`,
                method: 'GET',
            }),
        enabled: Boolean(userId),
    });
}
